<dialog
  #dialog
  class="document-delete-dialog"
  [attr.aria-labelledby]="i18nPrefix + '-delete-title'"
  (cancel)="dialogCancel.emit($event)"
>
  @if (active) {
    <h3 [id]="i18nPrefix + '-delete-title'">
      {{ key('deleteTitle') | translate }}
    </h3>
    <p>
      {{
        key('deleteBody')
          | translate
            : {
                type: (typeKey() | translate),
                file: fileName || ('common.dash' | translate)
              }
      }}
    </p>
    @if (errorMessage) {
      <p class="document-delete-error">
        {{ errorMessage }}
      </p>
    }
    <div class="document-delete-actions">
      <button
        type="button"
        class="document-delete-cancel"
        [disabled]="deleting"
        (click)="cancelRequest.emit()"
      >
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="button"
        class="document-delete-confirm"
        [disabled]="deleting"
        (click)="confirmRequest.emit()"
      >
        {{
          deleting
            ? ('common.deleting' | translate)
            : ('common.delete' | translate)
        }}
      </button>
    </div>
  }
</dialog>
